;(function( $ ) {
	'use strict';
	$( document ).ready( function() {
		// No browser support for object fit? Then we'll abuse background image cover.
		if ( typeof Modernizr === 'object' && ( !Modernizr.objectfit && Modernizr.bgsizecover ) ) {
			$( '.gallery > figure > .gallery-icon a, .fixed-height:not(.hero-header-image), .figure-with-caption.aligncenter, .card-excerpt .thumb img' ).each( function( i, obj ) {
				var $self = $( this ),
					$img  = $self.children( 'img' );

				if ( $img.length ) {
					$img
						.css( { visibility: 'hidden' } )
						.wrap( '<div class="object-fit-fix"></div>' )
						.parent( '.object-fit-fix' )
						.css( {
								  backgroundImage: 'url(\'' + $img.attr( 'src' ) + '\')',
								  backgroundSize: 'cover'
							  } );

					$img.on( 'lazyafterunveil', function( elem ) {
						$( this )
							.parent( '.object-fit-fix' )
							.css( {
									  backgroundImage: 'url(\'' + $( this ).attr( 'src' ) + '\')',
									  backgroundSize: 'cover'
								  } );
					} );
				}
			} );
		}
	} );
}( jQuery ));
